import React, { Component } from "react";
import { Outlet } from "react-router-dom";
class Forms extends Component {

  render() {
    return (
      <>
        <div>
          <Outlet />
        </div>
      </>
    );
  }
}

export default Forms;
